import React, { useState } from 'react';
import { translate } from 'utils/utils';
import { useField } from 'react-final-form';
import AppStorage from 'Storage/Storage';
import { AddressModel } from 'FormInputs/InputAddress/InputAddress';
import Labels from '../../../enums/Labels';
import { TafAddressInput, TafValidationResult } from '@taf-ui/react';
import { Address, TafChangeEvent } from '@taf-ui/core';

type Props = {
  addressModel: AddressModel;
  onBlurHandler: () => Promise<void>;
  name: 'insured'
};

const LocalZipCodeHouseNumberInput = (props: Props) => {

  const storage = AppStorage.getInstance();

  const [queryInProgress, setQueryInProgress] = useState(false);
  const [zipCodeNotFound, setZipCodeNotFound] = useState(false);
  const zipCodeField = useField(props.addressModel.zipCode);
  const numberField = useField(props.addressModel.houseNumber);
  const suffixField = useField(props.addressModel.houseLetter);
  const cityField = useField(props.addressModel.city);
  const streetField = useField(props.addressModel.street);

  const [isChanged, setIsChanged] = useState(false);

  const onBlur = (): void => {
    const {
      onBlurHandler,
    } = props;

    setQueryInProgress(true);
    setZipCodeNotFound(false);

    onBlurHandler()
      .catch(() => {
        setZipCodeNotFound(true);
      })
      .finally(() => {
        setQueryInProgress(false);
      });
  };

  const handleChange = (e: CustomEvent<TafChangeEvent<Address>>) => {
    setIsChanged(true);

    zipCodeField.input.onChange(e.detail.value.zipCode);
    numberField.input.onChange(e.detail.value.number);
    suffixField.input.onChange(e.detail.value.suffix);
    cityField.input.onChange(e.detail.value.city);
    streetField.input.onChange(e.detail.value.street);
    onBlur();
  };

  const validateAddress = () => {
    if (zipCodeField.meta.error && (zipCodeField.meta.touched || isChanged)) {
      return translate(zipCodeField.meta.error as Labels, storage.getLocale);
    }
    if (numberField.meta.error && (numberField.meta.touched || isChanged)) {
      return translate(numberField.meta.error as Labels, storage.getLocale);
    }
    if (cityField.meta.error && (cityField.meta.touched || isChanged)) {
      return translate(cityField.meta.error as Labels, storage.getLocale);
    }
    if (streetField.meta.error && (streetField.meta.touched || isChanged)) {
      return translate(streetField.meta.error as Labels, storage.getLocale);
    }
  };

  return (
      <div className="local zip-code-house-number">
        <div className="zip-code-house-number-label">
          <TafAddressInput
            inputId={props.name}
            name={props.name}
            labels={{
              zipCode: translate(Labels.PERSONAL_DETAILS_ZIP_CODE_HOUSE_NUMBER, storage.getLocale),
              number: '',
              suffix: translate(Labels.PERSONAL_DETAILS_HOUSE_LETTER, storage.getLocale),
              city: translate(Labels.PERSONAL_DETAILS_RESIDENCE, storage.getLocale),
              street: translate(Labels.PERSONAL_DETAILS_STREET, storage.getLocale),
            }}
            value={{
              zipCode: zipCodeField.input.value as string,
              number: numberField.input.value as string,
              suffix: suffixField.input.value as string,
              city: cityField.input.value as string,
              street: streetField.input.value as string,
            }}
            required={true}
            onTafChange={handleChange}
            searchInProgress={queryInProgress}
            validationMessage={validateAddress()}
            validationState={validateAddress() ? 'error' : undefined}
          />
        </div>
        {zipCodeNotFound &&
          <TafValidationResult state="warning" messages={translate(Labels.PERSONAL_DETAILS_ZIP_CODE_NO_RESULT, storage.getLocale)} />
        }
      </div>
  );
};
export default LocalZipCodeHouseNumberInput;
